export default "__VITE_ASSET__DP05mYwr__"